module.exports = __webpack_public_path__ + "img/graph-stats-descend.46bd2cdc.svg";